var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "51px",
    viewBox: "0 0 61 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0DDBC41E-4B4F-422E-BDBD-933E11C4CF36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-what-can-help",
    transform: "translate(-885.000000, -580.000000)",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(887.000000, 581.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.016950)",
    stroke: "#222456"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "-1.5e-05 48.750015 15.958635 45.156465 15.958635 4.924515 -1.5e-05 0.133215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "57.78645 48.74988 41.82795 45.15633 41.82795 4.92468 57.78645 0.13323"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-6",
    stroke: "#222456",
    points: "15.95865 45.1734 41.82795 45.1734 41.82795 4.94145 15.95865 4.94145"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(3.600000, 23.566950)",
    stroke: "#ED7330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.058575,0.84993 C0.058575,1.31478 0.435375,1.69143 0.900075,1.69143 C1.364775,1.69143 1.741575,1.31478 1.741575,0.84993 C1.741575,0.38523 1.364775,0.00858 0.900075,0.00858 C0.435375,0.00858 0.058575,0.38523 0.058575,0.84993 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.84498,0.84993 C48.84498,1.31478 49.22178,1.69143 49.68648,1.69143 C50.15118,1.69143 50.52798,1.31478 50.52798,0.84993 C50.52798,0.38523 50.15118,0.00858 49.68648,0.00858 C49.22178,0.00858 48.84498,0.38523 48.84498,0.84993 Z",
    id: "Stroke-9"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoors);
export default __webpack_public_path__ + "static/media/doors.cf40a955.svg";
export { ForwardRef as ReactComponent };